import React, { createContext, useContext, useEffect, useState } from "react";

const OrderContext = createContext(null);

export const useOrder = () => useContext(OrderContext);

export const OrderProvider = ({ children }) => {
  const [orderReference, setOrderReference] = useState("");
  const [shippingAddress, setShippingAddress] = useState({});
  const [deliveryMethod, setDeliveryMethod] = useState("");
  const [orderItems, setOrderItems] = useState([]);
  const [comments, setComments] = useState("");
  const [ipAddress, setIpAddress] = useState(null);

  const clearOrder = () => {
    setOrderReference("");
    setShippingAddress({});
    setDeliveryMethod("");
    setOrderItems([]);
    setComments("");
  };
  useEffect(() => {
    const fetchIp = async () => {
      try {
        const response = await fetch("https://api.ipify.org/?format=json");
        if (response.status === 200) {
          const data = await response.json();
          setIpAddress(data.ip);
        }
      } catch (error) {
        console.error("Error fetching IP:", error);
      }
    };

    fetchIp();
  }, []);

  return (
    <OrderContext.Provider
      value={{
        orderReference,
        setOrderReference,
        shippingAddress,
        setShippingAddress,
        deliveryMethod,
        setDeliveryMethod,
        orderItems,
        setOrderItems,
        comments,
        setComments,
        clearOrder,
        ipAddress,
      }}
    >
      {children}
    </OrderContext.Provider>
  );
};
